module.exports = __webpack_public_path__ + "media/images/lb/523-9bc7f252841c8bfbc92ecd848f3a15c4.svg";